/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgMemberCreateRequest } from '../models/OrgMemberCreateRequest';
import type { OrgMemberResponse } from '../models/OrgMemberResponse';
import type { OrgMemberUpdateRequest } from '../models/OrgMemberUpdateRequest';
import type { OrgMemberWorkspaceCreateRequest } from '../models/OrgMemberWorkspaceCreateRequest';
import type { OrgMemberWorkspaceResponse } from '../models/OrgMemberWorkspaceResponse';
import type { OrgMemberWorkspaceSortRequest } from '../models/OrgMemberWorkspaceSortRequest';
import type { PaginatedResponse_OrgMemberResponse_ } from '../models/PaginatedResponse_OrgMemberResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrgMemberService {
    /**
     * Create Org Member
     *     기관 멤버 생성
     *
     * 새로운 기관 멤버를 생성합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgMemberResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsCreateOrgMember({
        requestBody,
    }: {
        requestBody: OrgMemberCreateRequest,
    }): CancelablePromise<OrgMemberResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/member',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Org Members
     * 기관 멤버 목록 조회 및 검색
     *
     * 기관 멤버를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * org_id: 기관 ID (필수)
     * workspace_id: 워크스페이스 ID로 필터링 (선택사항) - 해당 워크스페이스에 속한 멤버만 조회
     * q: 검색 키워드 (선택사항) - 닉네임, 계정명, 이메일로 검색
     * include_unavailable: 비활성 멤버 포함 여부 (기본값: False)
     * - True인 경우 owner 또는 admin 권한 필요
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse_OrgMemberResponse_ OK
     * @throws ApiError
     */
    public static appsOrganizationViewsListOrgMembers({
        orgId,
        workspaceId,
        q,
        includeUnavailable = false,
        page = 1,
        perPage = 100,
    }: {
        orgId: string,
        workspaceId?: string,
        q?: string,
        includeUnavailable?: boolean,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_OrgMemberResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/member',
            query: {
                'org_id': orgId,
                'workspace_id': workspaceId,
                'q': q,
                'include_unavailable': includeUnavailable,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Current Org Member
     * 현재 인증된 사용자의 기관 멤버 정보 조회
     *
     * 인증된 사용자의 ID와 제공된 org_id를 기반으로 OrgMember 정보를 조회합니다.
     *
     * Args:
     * org_id: 기관 ID (필수)
     * @returns OrgMemberResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsGetCurrentOrgMember({
        orgId,
    }: {
        orgId: string,
    }): CancelablePromise<OrgMemberResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/member/me',
            query: {
                'org_id': orgId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Org Member Add Workspace
     *     기관 멤버 워크스페이스 추가
     *
     * 기관 멤버를 특정 워크스페이스에 추가합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgMemberWorkspaceResponse Created
     * @throws ApiError
     */
    public static appsOrganizationViewsOrgMemberAddWorkspace({
        requestBody,
    }: {
        requestBody: OrgMemberWorkspaceCreateRequest,
    }): CancelablePromise<OrgMemberWorkspaceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/member/workspace',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Org Member Remove Workspace
     * 기관 멤버 워크스페이스 제거
     *
     * 기관 멤버를 특정 워크스페이스에서 제거합니다.
     * 본인이거나 기관 관리자(owner/admin)인 경우 제거 가능합니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsOrganizationViewsOrgMemberRemoveWorkspace({
        memberId,
        workspaceId,
    }: {
        memberId: string,
        workspaceId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/org/member/{member_id}/workspace/{workspace_id}',
            path: {
                'member_id': memberId,
                'workspace_id': workspaceId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Org Member Workspace Sort
     * 기관 멤버 워크스페이스 정렬 순서 변경
     *
     * 본인의 워크스페이스 정렬 순서(sort_key)를 변경합니다.
     * sort_key가 다른 항목과 겹치면 자동으로 조정됩니다.
     * @returns OrgMemberWorkspaceResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsUpdateOrgMemberWorkspaceSort({
        workspaceId,
        requestBody,
    }: {
        workspaceId: string,
        requestBody: OrgMemberWorkspaceSortRequest,
    }): CancelablePromise<OrgMemberWorkspaceResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/org/member/workspace/{workspace_id}/sort',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Org Member
     * 기관 멤버 조회
     *
     * ID로 특정 기관 멤버를 조회합니다.
     * @returns OrgMemberResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsGetOrgMember({
        memberId,
    }: {
        memberId: string,
    }): CancelablePromise<OrgMemberResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/member/{member_id}',
            path: {
                'member_id': memberId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Org Member
     *     기관 멤버 정보 수정
     *
     * 특정 기관 멤버의 정보를 수정합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgMemberResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsUpdateOrgMember({
        memberId,
        requestBody,
    }: {
        memberId: string,
        requestBody: OrgMemberUpdateRequest,
    }): CancelablePromise<OrgMemberResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/org/member/{member_id}',
            path: {
                'member_id': memberId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Org Member
     *     기관 멤버 삭제
     *
     * 특정 기관 멤버를 삭제합니다. (소프트 삭제)
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsOrganizationViewsDeleteOrgMember({
        memberId,
    }: {
        memberId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/org/member/{member_id}',
            path: {
                'member_id': memberId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
